import { FolderContent } from '@/api/generatedApi';
import { AssetNameWithExtension } from '@/components/AssetNameWithExtension';
import { Ellipsis } from '@/components/Ellipsis';
import { FolderIcon } from '@/components/FolderIcon';
import { Thumbnail } from '@/components/Thumbnail';
import { getAssetName } from '@/utils/assets';
import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { getFileExtension } from '@physna/supported-files';

export const RenderName = (parameters: GridRenderCellParams<FolderContent>) => {
  return parameters.row.contentType === 'asset' ? (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 1 }}>
      <Thumbnail size={42} asset={parameters.row} />
      <AssetNameWithExtension
        name={getAssetName(parameters.row)}
        path={parameters.row.path}
        extension={getFileExtension(parameters.row.path)}
        showAssemblyPill={parameters.row.isAssembly}
        isRootAssembly={parameters.row.isRootAssembly}
        isMissingDependencies={parameters.row.isMissingDependencies}
      />
    </Box>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FolderIcon />
      <Ellipsis text={parameters.row.name} />
    </Box>
  );
};
